import { ChangeDetectionStrategy, Component, input, model } from '@angular/core'

import { RippleDirective } from '../ripple/ripple.directive'
import { SwitchingChevronComponent } from '../switching-chevron/switching-chevron.component'

@Component({
  selector: 'pai-accordion-item',
  templateUrl: './accordion-item.component.html',
  styleUrls: ['./accordion-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RippleDirective, SwitchingChevronComponent],
})
export class AccordionItemComponent {
  private static instanceCounter = 0

  readonly title = input.required<string>()
  readonly isCollapsed = model(true)

  protected readonly instanceId = AccordionItemComponent.instanceCounter++
  protected readonly contentId = 'accordion-item-content-' + this.instanceId

  toggleState() {
    this.isCollapsed.update((v) => !v)
  }
}
